import React, {useState} from "react"
import "./button.scss"
import { Link } from 'gatsby'
import ModalProduct from "../modal-product/modal-products"


const Button = ({ disable = false, children, label, url, btnType = "primary", clickAction, additionalClass }) => {

    const [openModal, setOpenModal] = useState(false);
    const [originProduct, setOriginProduct] = useState("");

    let productsObject;

    const originMapper = {

        "/vehicle-warranty-insurance": "MBI",
        "/alloy-insurance": "Alloy Wheel",
        "/cosmetic-repair-insurance": "Cosmetic Repair",
        "/tyre-insurance": "Tyre",
        "/gap-insurance": "Gap",
        '/excess-insurance': 'Excess'
    }

    if (typeof window !== "undefined" && window.sessionStorage.getItem("products")) {
        productsObject = JSON.parse(sessionStorage.getItem("products")).products;
    }

    return (
        <>
            <div className={`button button-${btnType} ${additionalClass}`}>
                {
                    productsObject && typeof children === 'string' && ( children.toLowerCase().indexOf("get a quote") !== -1 || children.toLowerCase().indexOf("purchase cover") !== -1) && originMapper[window.location.pathname] ?

                        <button type="button" disable={disable} onClick={() => {
                            
                                setOpenModal(true); 
                                setOriginProduct(originMapper[window.location.pathname])
                            
                        }}>
                            {children}
                        </button>
                    :
                    
                    url ? <Link to={url}>{children}</Link> 
                    
                    :

                        <button type="button" onClick={clickAction} disable={disable}>
                            {children}
                        </button>
                }

            </div>

            <ModalProduct
                setOpenModal={setOpenModal}
                openModal={openModal}
                originProduct={originProduct}
                products={productsObject}
            />
        </>
    )
}

export default Button